import { useEffect, useRef } from "react";

export const useIdleTimer = ({
  onIdle,
  onActive,
  timeout = 10 * 60 * 1000,
  isEnabled = true,
}) => {
  const timerRef = useRef(null);
  const idleRef = useRef(false); // tracks idle state

  useEffect(() => {
    if (!isEnabled) return;

    const handleActivity = () => {
      if (idleRef.current) {
        // user was idle but now active
        idleRef.current = false;
        if (onActive) onActive();
      }
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => {
        idleRef.current = true;
        onIdle();
      }, timeout);
    };

    const events = [
      "mousemove",
      "mousedown",
      "keydown",
      "scroll",
      "touchstart",
    ];

    events.forEach((event) => window.addEventListener(event, handleActivity));
    // start the timer initially
    handleActivity();

    return () => {
      events.forEach((event) =>
        window.removeEventListener(event, handleActivity)
      );
      clearTimeout(timerRef.current);
    };
  }, [onIdle, onActive, timeout, isEnabled]);
};
